import * as S from './styles';

const RecordEntriesLoadingSkeleton: React.FC = () => {
  return (
    <S.Container data-testid="recordEntriesLoadingSkeleton">
      <S.LoadingContainer data-testid="loadingContainer">
        <S.FirstLine />
        <S.SecondLine />
      </S.LoadingContainer>
      <S.LoadingContainer data-testid="loadingContainer">
        <S.FirstLine />
        <S.SecondLine />
      </S.LoadingContainer>
    </S.Container>
  );
};

export default RecordEntriesLoadingSkeleton;
